<div *ngIf="!tokenLoginOnload" style="display: none;">
    <iframe
        [src]="tokenLoginUrl"
        *ngIf="chatModuleEnabled"
        #iframe
        frameBorder="0"
    ></iframe>
</div>
